import { colors } from '@cdl/heartbeat-react';
import { mean } from 'lodash';
import {
  getNumberOfPointsFromDuration,
  SIDE_POINTS,
} from '../../clustering/client/helpers';
import { ClusterBeat } from '../../clustering/clustering.types';
import { Scale } from '../../plot/types/scale';
import { roundPixel } from '../../utils/math';

const SHADOW_COLOR = '#B3B3B3';

export const drawBeats = (
  xScale: Scale,
  yScale: Scale,
  canvasWidth: number,
  canvasHeight: number,
  beatStripEl: HTMLCanvasElement | null,
  beats?: ClusterBeat[],
  beatRectangleEl?: HTMLCanvasElement | null,
  isShadow?: boolean,
  offsetY = 0,
) => {
  const beatStripCtx = beatStripEl?.getContext('2d');
  const beatRectangleCtx = beatRectangleEl?.getContext('2d');
  const beatOffsets: number[] = [];
  const ratio = 2; // TODO: window.devicePixelRatio || 1;

  if (beats == null) {
    beatStripCtx?.clearRect(0, 0, canvasWidth, canvasHeight);
  }

  // main strip
  if (beatStripEl != null && beats != null && beatStripCtx != null) {
    setUpPixelRatio(
      canvasWidth,
      canvasHeight,
      beatStripEl,
      beatStripCtx,
      ratio,
    );
    beatStripCtx.beginPath();
    beatStripCtx.clearRect(0, 0, canvasWidth, canvasHeight);
    beatStripCtx.strokeStyle = isShadow ? SHADOW_COLOR : 'black';
    beats.forEach((beat) => {
      beat.data.forEach((point, index) => {
        drawPath(beatStripCtx, xScale, yScale, index, point, offsetY);
      });
      beatOffsets.push(getNumberOfPointsFromDuration(beat.offset - beat.onset));
    });
    beatStripCtx.stroke();
  }

  // beat rectangle
  const rectOnset = SIDE_POINTS + 1; // we show 600 fiducial points before the beat onset
  const x = roundPixel(xScale(rectOnset));
  const meanOffset = mean(beatOffsets);
  const width = roundPixel(xScale(meanOffset));

  if (beatRectangleEl != null) {
    beatRectangleCtx?.clearRect(0, 0, canvasWidth, canvasHeight);
    if (beatRectangleCtx != null) {
      setUpPixelRatio(
        canvasWidth,
        canvasHeight,
        beatRectangleEl,
        beatRectangleCtx,
        ratio,
      );
      beatRectangleCtx.globalAlpha = 0.2;
      beatRectangleCtx.fillStyle = colors.primary[500];
    }
    beatRectangleCtx?.fillRect(x, 0, width, canvasHeight);
    beatRectangleCtx?.stroke();
  }
};

const drawPath = (
  ctx: CanvasRenderingContext2D,
  xScale: Scale,
  yScale: Scale,
  x: number,
  y: number | null,
  offsetY = 0,
) => {
  if (y == null) {
    return;
  }
  const scaledX = roundPixel(xScale(x));
  const scaledY = roundPixel(yScale(y) + offsetY);
  if (x === 0) {
    ctx.moveTo(scaledX, scaledY);
  } else {
    ctx.lineTo(scaledX, scaledY);
  }
};

export const setUpPixelRatio = (
  width: number,
  height: number,
  canvasElement: HTMLCanvasElement,
  canvasCtx: CanvasRenderingContext2D,
  ratio: number,
) => {
  canvasElement.style.width = `${width}px`;
  canvasElement.style.height = `${height}px`;

  canvasElement.width = Math.floor(width * ratio);
  canvasElement.height = Math.floor(height * ratio);
  canvasCtx.scale(ratio, ratio);
};
